import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TemplateComponent from 'react-mustache-template-component';
import { ReactComponent as FacebookIcon } from 'assets/icon-facebook.svg';
import { ReactComponent as YoutubeIcon } from 'assets/icon-youtube.svg';
import { ReactComponent as TwitterIcon } from 'assets/icon-twitter.svg';
import { ReactComponent as LinkedinIcon } from 'assets/icon-linkedin.svg';
import { fonts, device } from 'shared/defaultTheme';

const Footer = ({
  backgroundColor,
  logoSrc,
  footerText,
  iconColor,
  textColor,
  facebookLink,
  linkedinLink,
  youtubeLink,
  twitterLink,
  phone,
  showLogoFooter,
}) => {
  const goToOutside = (link) => {
    if (!link.match(/^https?:\/\//i)) {
      window.open(`http://${link}`, '_blank');
      return;
    }
    window.open(link, '_blank');
  };
  return (
    <div className="footer" style={{ backgroundColor }}>
      <div className="footer__logo-text__wrapper">
        {showLogoFooter && <Logo imageSrc={logoSrc} />}
        <div style={{ color: textColor }} className="footer__text__wrapper list-client__text">
          <TemplateComponent template={footerText} />
        </div>
      </div>
      <div className="footer__icons_phone_wrapper">
        <PhoneText color={textColor}>{phone}</PhoneText>
        <div className="footer__icons_wrapper">
          {facebookLink && (
            <IconContainer color={iconColor} onClick={() => goToOutside(facebookLink)}>
              <FacebookIcon className="footer__icon" fill={backgroundColor} />
            </IconContainer>
          )}
          {linkedinLink && (
            <IconContainer color={iconColor} onClick={() => goToOutside(linkedinLink)}>
              <LinkedinIcon className="footer__icon" fill={backgroundColor} />
            </IconContainer>
          )}

          {youtubeLink && (
            <IconContainer color={iconColor} onClick={() => goToOutside(youtubeLink)}>
              <YoutubeIcon className="footer__icon" fill={backgroundColor} />
            </IconContainer>
          )}
          {twitterLink && (
            <IconContainer color={iconColor} onClick={() => goToOutside(twitterLink)}>
              <TwitterIcon className="footer__icon" fill={backgroundColor} />
            </IconContainer>
          )}
        </div>
      </div>
    </div>
  );
};

const Logo = styled.div(({ imageSrc }) => ({
  background: `url('${imageSrc}')`,
  backgroundPosition: 'center',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  width: '176px',
  height: '72px',
}));

const IconContainer = styled.div(({ color }) => ({
  width: '24px',
  height: '24px',
  backgroundColor: color,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: '16px',
  borderRadius: 50,
  cursor: 'pointer',
}));

const PhoneText = styled.span`
  color: ${({ color }) => color};
  font-family: ${fonts.medium};
  font-weight: 500;
  letter-spacing: 2.5px;
  line-height: 31px;
  text-align: center;

  @media ${device.sm} {
    font-size: 20px;
  }

  @media ${device.md} {
    font-size: 23px;
  }
  @media ${device.lg} {
    font-size: 23px;
  }
  @media ${device.xl} {
    font-size: 23px;
  }
`;

Footer.defaultProps = {
  phone: '',
  textColor: undefined,
  showLogoFooter: false,
};

Footer.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  logoSrc: PropTypes.string.isRequired,
  footerText: PropTypes.string.isRequired,
  iconColor: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  facebookLink: PropTypes.string.isRequired,
  linkedinLink: PropTypes.string.isRequired,
  youtubeLink: PropTypes.string.isRequired,
  twitterLink: PropTypes.string.isRequired,
  phone: PropTypes.string,
  showLogoFooter: PropTypes.bool,
};

export default Footer;
